<template>
  <basic-layout :menu="false">
    <template #headerLeft>
      <router-link
        :to="{
          name: 'Home',
        }"
      >
        <a-button class="inner-menu-layout__button" icon="arrow-left">返回首页</a-button>
      </router-link>
    </template>
    <div class="inner-menu-layout__content">
      <inner-menu
        class="inner-menu-layout__menu"
        :menu="menu"
        :openKeys="menuOptions && menuOptions.openKeys"
        :selectedKeys="menuOptions && menuOptions.selectedKeys"
      />
      <div class="inner-menu-layout__main">
        <router-view />
      </div>
    </div>
  </basic-layout>
</template>

<script>
import BasicLayout from '../BasicLayout.vue';
import InnerMenu from './InnerMenu.vue';

export default {
  name: 'InnerMenuLayout',
  components: {
    BasicLayout,
    InnerMenu,
  },
  props: {
    menu: {
      type: Array,
      required: true,
    },
    menuOptions: {
      type: Object,
      default() {
        return undefined;
      },
    },
  },
};
</script>

<style lang="less" scoped>
.inner-menu-layout {
  &__button {
    margin: 0 @padding-lg;
  }

  &__content {
    display: flex;
    height: 100%;
  }

  &__menu {
    margin-right: @padding-xl;
    flex: none;
  }

  &__main {
    width: 100%;
  }
}
</style>
